export default {
  campaigns: [],
  creatingCampaign: false,
  creatingCampaignFailed: false,
  creatingCampaignSucceeded: false,

  campaignDetail: {},
  loadingCampaignDetail: false,
  loadingCampaignDetailSucceeded: false,
  loadingCampaignDetailFailed: false,

  loadingCampaigns: false,
  loadingCampaignsFailed: false,
  loadingCampaignsError: null,
  loadingCampaignsSucceeded: false,

  replyMessages: [],
  loadingReplyMessages: false,
  loadReplyMessagesFailed: false,
  loadReplyMessagesSuccess: false,

  downloadingCampaignMessages: false,
  downloadingCampaignMessagesFailed: false,
  downloadingCampaignMessagesSucceeded: false,
  downloadingCampaignMessagesError: null,

  creatingRandomSelection: false,
  creatingRandomSelectionFailed: false,
  creatingRandomSelectionSucceeded: false,
  creatingRandomSelectionError: null,

  randomSelections: null,
  loadingRandomSelections: false,
  loadingRandomSelectionsSucceeded: false,
  loadingRandomSelectionsFailed: false,

  settingRandomSelectionWinner: false,
  setRandomSelectionWinnerFailed: false,
  setRandomSelectionWinnerSucceeded: false,

  filterTitle: null,
  filterType: null,
  filterIsActive: true,
  filterSortBy: 'title_ascending',
  filterPage: 1,
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign/state.js